import { default as _91_46_46_46slug_93SzEUphgCmBMeta } from "/Users/olivermurphy/Code/spas/justhire/pages/[...slug].vue?macro=true";
import { default as _91location_938cdphO2O5fMeta } from "/Users/olivermurphy/Code/spas/justhire/pages/[category]/near-me/[location].vue?macro=true";
import { default as indexgMEhCLZJblMeta } from "/Users/olivermurphy/Code/spas/justhire/pages/[category]/near-me/index.vue?macro=true";
import { default as indexo5w8yNZZ8TMeta } from "/Users/olivermurphy/Code/spas/justhire/pages/booking/add-on/index.vue?macro=true";
import { default as _91attributeUuid_93H2tRbn0enlMeta } from "/Users/olivermurphy/Code/spas/justhire/pages/booking/attribute/[attributeUuid].vue?macro=true";
import { default as basketxqxHxK6eQyMeta } from "/Users/olivermurphy/Code/spas/justhire/pages/booking/basket.vue?macro=true";
import { default as _91_91categoryUuid_93_930fE9ANdnknMeta } from "/Users/olivermurphy/Code/spas/justhire/pages/booking/category/[[categoryUuid]].vue?macro=true";
import { default as checkoutvF59bnT50ZMeta } from "/Users/olivermurphy/Code/spas/justhire/pages/booking/checkout.vue?macro=true";
import { default as confirmationaWUWc4BOEnMeta } from "/Users/olivermurphy/Code/spas/justhire/pages/booking/confirmation.vue?macro=true";
import { default as end_45date3m2zHBIvvDMeta } from "/Users/olivermurphy/Code/spas/justhire/pages/booking/end-date.vue?macro=true";
import { default as _91categoryUuid_93iMb29Uhj5VMeta } from "/Users/olivermurphy/Code/spas/justhire/pages/booking/equipment-type/[categoryUuid].vue?macro=true";
import { default as locationepsqHgGX2HMeta } from "/Users/olivermurphy/Code/spas/justhire/pages/booking/location.vue?macro=true";
import { default as handlerj4gN9fqnUsMeta } from "/Users/olivermurphy/Code/spas/justhire/pages/booking/payment/handler.vue?macro=true";
import { default as indexwwmyVT5SBZMeta } from "/Users/olivermurphy/Code/spas/justhire/pages/booking/payment/index.vue?macro=true";
import { default as _91orderReference_93i9FqskGHJTMeta } from "/Users/olivermurphy/Code/spas/justhire/pages/booking/regenerate/[orderReference].vue?macro=true";
import { default as start_45dateRkeE7ECLsbMeta } from "/Users/olivermurphy/Code/spas/justhire/pages/booking/start-date.vue?macro=true";
import { default as contact_45uszYDZAo1QnvMeta } from "/Users/olivermurphy/Code/spas/justhire/pages/contact-us.vue?macro=true";
import { default as _91equipmentTypeSlug_93m5rMRO8i2rMeta } from "/Users/olivermurphy/Code/spas/justhire/pages/equipment/[equipmentTypeSlug].vue?macro=true";
import { default as _91attributeValueSlug_93uiKdrNpq4JMeta } from "/Users/olivermurphy/Code/spas/justhire/pages/equipment/attributes/[categorySlug]/[attributeSlug]/[attributeValueSlug].vue?macro=true";
import { default as _91_46_46_46categorySlug_936Sv7AzbynwMeta } from "/Users/olivermurphy/Code/spas/justhire/pages/equipment/categories/[...categorySlug].vue?macro=true";
import { default as indexPjTREvs3FbMeta } from "/Users/olivermurphy/Code/spas/justhire/pages/index.vue?macro=true";
import { default as _91articleSlug_930CjZ0K8MFjMeta } from "/Users/olivermurphy/Code/spas/justhire/pages/knowledge/[articleSlug].vue?macro=true";
import { default as _91_46_46_46slug_934EsJJXn2IpMeta } from "/Users/olivermurphy/Code/spas/justhire/pages/knowledge/c/[...slug].vue?macro=true";
import { default as my_45booking1pzoVfLkSGMeta } from "/Users/olivermurphy/Code/spas/justhire/pages/my-booking.vue?macro=true";
import { default as _91slug_93nkMMHvfq2NMeta } from "/Users/olivermurphy/Code/spas/justhire/pages/partners/[slug].vue?macro=true";
import { default as _91_46_46_46slug_93lNlJ6s0G7mMeta } from "/Users/olivermurphy/Code/spas/justhire/pages/pl/[...slug].vue?macro=true";
import { default as _91email_93C22S22OmM5Meta } from "/Users/olivermurphy/Code/spas/justhire/pages/supplier/manage-booking/[orderReference]/[email].vue?macro=true";
import { default as component_45stubtE53tTHnppMeta } from "/Users/olivermurphy/Code/spas/justhire/node_modules/nuxt/dist/pages/runtime/component-stub.js?macro=true";
import { default as component_45stubtE53tTHnpp } from "/Users/olivermurphy/Code/spas/justhire/node_modules/nuxt/dist/pages/runtime/component-stub.js";
export default [
  {
    name: "slug",
    path: "/:slug(.*)*",
    component: () => import("/Users/olivermurphy/Code/spas/justhire/pages/[...slug].vue")
  },
  {
    name: "category-near-me-location",
    path: "/:category()/near-me/:location()",
    component: () => import("/Users/olivermurphy/Code/spas/justhire/pages/[category]/near-me/[location].vue")
  },
  {
    name: "category-near-me",
    path: "/:category()/near-me",
    component: () => import("/Users/olivermurphy/Code/spas/justhire/pages/[category]/near-me/index.vue")
  },
  {
    name: "booking-add-on",
    path: "/booking/add-on",
    meta: indexo5w8yNZZ8TMeta || {},
    component: () => import("/Users/olivermurphy/Code/spas/justhire/pages/booking/add-on/index.vue")
  },
  {
    name: "booking-attribute-attributeUuid",
    path: "/booking/attribute/:attributeUuid()",
    meta: _91attributeUuid_93H2tRbn0enlMeta || {},
    component: () => import("/Users/olivermurphy/Code/spas/justhire/pages/booking/attribute/[attributeUuid].vue")
  },
  {
    name: "booking-basket",
    path: "/booking/basket",
    meta: basketxqxHxK6eQyMeta || {},
    component: () => import("/Users/olivermurphy/Code/spas/justhire/pages/booking/basket.vue")
  },
  {
    name: "booking-category-categoryUuid",
    path: "/booking/category/:categoryUuid?",
    meta: _91_91categoryUuid_93_930fE9ANdnknMeta || {},
    component: () => import("/Users/olivermurphy/Code/spas/justhire/pages/booking/category/[[categoryUuid]].vue")
  },
  {
    name: "booking-checkout",
    path: "/booking/checkout",
    meta: checkoutvF59bnT50ZMeta || {},
    component: () => import("/Users/olivermurphy/Code/spas/justhire/pages/booking/checkout.vue")
  },
  {
    name: "booking-confirmation",
    path: "/booking/confirmation",
    meta: confirmationaWUWc4BOEnMeta || {},
    component: () => import("/Users/olivermurphy/Code/spas/justhire/pages/booking/confirmation.vue")
  },
  {
    name: "booking-end-date",
    path: "/booking/end-date",
    meta: end_45date3m2zHBIvvDMeta || {},
    component: () => import("/Users/olivermurphy/Code/spas/justhire/pages/booking/end-date.vue")
  },
  {
    name: "booking-equipment-type-categoryUuid",
    path: "/booking/equipment-type/:categoryUuid()",
    meta: _91categoryUuid_93iMb29Uhj5VMeta || {},
    component: () => import("/Users/olivermurphy/Code/spas/justhire/pages/booking/equipment-type/[categoryUuid].vue")
  },
  {
    name: "booking-location",
    path: "/booking/location",
    meta: locationepsqHgGX2HMeta || {},
    component: () => import("/Users/olivermurphy/Code/spas/justhire/pages/booking/location.vue")
  },
  {
    name: "booking-payment-handler",
    path: "/booking/payment/handler",
    meta: handlerj4gN9fqnUsMeta || {},
    component: () => import("/Users/olivermurphy/Code/spas/justhire/pages/booking/payment/handler.vue")
  },
  {
    name: "booking-payment",
    path: "/booking/payment",
    meta: indexwwmyVT5SBZMeta || {},
    component: () => import("/Users/olivermurphy/Code/spas/justhire/pages/booking/payment/index.vue")
  },
  {
    name: "booking-regenerate-orderReference",
    path: "/booking/regenerate/:orderReference()",
    meta: _91orderReference_93i9FqskGHJTMeta || {},
    component: () => import("/Users/olivermurphy/Code/spas/justhire/pages/booking/regenerate/[orderReference].vue")
  },
  {
    name: "booking-start-date",
    path: "/booking/start-date",
    meta: start_45dateRkeE7ECLsbMeta || {},
    component: () => import("/Users/olivermurphy/Code/spas/justhire/pages/booking/start-date.vue")
  },
  {
    name: "contact-us",
    path: "/contact-us",
    component: () => import("/Users/olivermurphy/Code/spas/justhire/pages/contact-us.vue")
  },
  {
    name: "equipment-equipmentTypeSlug",
    path: "/equipment/:equipmentTypeSlug()",
    component: () => import("/Users/olivermurphy/Code/spas/justhire/pages/equipment/[equipmentTypeSlug].vue")
  },
  {
    name: "equipment-attributes-categorySlug-attributeSlug-attributeValueSlug",
    path: "/equipment/attributes/:categorySlug()/:attributeSlug()/:attributeValueSlug()",
    component: () => import("/Users/olivermurphy/Code/spas/justhire/pages/equipment/attributes/[categorySlug]/[attributeSlug]/[attributeValueSlug].vue")
  },
  {
    name: "equipment-categories-categorySlug",
    path: "/equipment/categories/:categorySlug(.*)*",
    component: () => import("/Users/olivermurphy/Code/spas/justhire/pages/equipment/categories/[...categorySlug].vue")
  },
  {
    name: "index",
    path: "/",
    component: () => import("/Users/olivermurphy/Code/spas/justhire/pages/index.vue")
  },
  {
    name: "knowledge-articleSlug",
    path: "/knowledge/:articleSlug()",
    component: () => import("/Users/olivermurphy/Code/spas/justhire/pages/knowledge/[articleSlug].vue")
  },
  {
    name: "knowledge-c-slug",
    path: "/knowledge/c/:slug(.*)*",
    component: () => import("/Users/olivermurphy/Code/spas/justhire/pages/knowledge/c/[...slug].vue")
  },
  {
    name: "my-booking",
    path: "/my-booking",
    component: () => import("/Users/olivermurphy/Code/spas/justhire/pages/my-booking.vue")
  },
  {
    name: "partners-slug",
    path: "/partners/:slug()",
    meta: _91slug_93nkMMHvfq2NMeta || {},
    component: () => import("/Users/olivermurphy/Code/spas/justhire/pages/partners/[slug].vue")
  },
  {
    name: "pl-slug",
    path: "/pl/:slug(.*)*",
    component: () => import("/Users/olivermurphy/Code/spas/justhire/pages/pl/[...slug].vue")
  },
  {
    name: "supplier-manage-booking-orderReference-email",
    path: "/supplier/manage-booking/:orderReference()/:email()",
    component: () => import("/Users/olivermurphy/Code/spas/justhire/pages/supplier/manage-booking/[orderReference]/[email].vue")
  },
  {
    name: component_45stubtE53tTHnppMeta?.name,
    path: "/home",
    component: component_45stubtE53tTHnpp
  },
  {
    name: component_45stubtE53tTHnppMeta?.name,
    path: "/equipment/2-yard-skip",
    component: component_45stubtE53tTHnpp
  },
  {
    name: component_45stubtE53tTHnppMeta?.name,
    path: "/equipment/4-yard-skip",
    component: component_45stubtE53tTHnpp
  },
  {
    name: component_45stubtE53tTHnppMeta?.name,
    path: "/equipment/6-yard-skip",
    component: component_45stubtE53tTHnpp
  },
  {
    name: component_45stubtE53tTHnppMeta?.name,
    path: "/equipment/8-yard-skip",
    component: component_45stubtE53tTHnpp
  },
  {
    name: component_45stubtE53tTHnppMeta?.name,
    path: "/equipment/10-yard-skip",
    component: component_45stubtE53tTHnpp
  },
  {
    name: component_45stubtE53tTHnppMeta?.name,
    path: "/equipment/12-yard-skip",
    component: component_45stubtE53tTHnpp
  },
  {
    name: component_45stubtE53tTHnppMeta?.name,
    path: "/equipment/14-yard-skip",
    component: component_45stubtE53tTHnpp
  },
  {
    name: component_45stubtE53tTHnppMeta?.name,
    path: "/equipment/16-yard-skip",
    component: component_45stubtE53tTHnpp
  },
  {
    name: component_45stubtE53tTHnppMeta?.name,
    path: "/knowledge/what-can-be-collected-by-grab-hire-",
    component: component_45stubtE53tTHnpp
  },
  {
    name: component_45stubtE53tTHnppMeta?.name,
    path: "/knowledge/do-you-need-insurance-to-hire-a-mini-digger-",
    component: component_45stubtE53tTHnpp
  },
  {
    name: component_45stubtE53tTHnppMeta?.name,
    path: "/equipment/categories/skips",
    component: component_45stubtE53tTHnpp
  },
  {
    name: component_45stubtE53tTHnppMeta?.name,
    path: "/equipment/categories/waste/skips",
    component: component_45stubtE53tTHnpp
  },
  {
    name: component_45stubtE53tTHnppMeta?.name,
    path: "/knowledge/what-can-I-put-into-a-skip",
    component: component_45stubtE53tTHnpp
  },
  {
    name: component_45stubtE53tTHnppMeta?.name,
    path: "/knowledge/what-can-i-put-into-a-skip",
    component: component_45stubtE53tTHnpp
  },
  {
    name: component_45stubtE53tTHnppMeta?.name,
    path: "/s/knowledge/what-can-you-put-into-a-skip",
    component: component_45stubtE53tTHnpp
  },
  {
    name: component_45stubtE53tTHnppMeta?.name,
    path: "/sl/skip-hire-",
    component: component_45stubtE53tTHnpp
  },
  {
    name: component_45stubtE53tTHnppMeta?.name,
    path: "/locations",
    component: component_45stubtE53tTHnpp
  },
  {
    name: component_45stubtE53tTHnppMeta?.name,
    path: "/locations/east-of-england",
    component: component_45stubtE53tTHnpp
  },
  {
    name: component_45stubtE53tTHnppMeta?.name,
    path: "/locations/north-east",
    component: component_45stubtE53tTHnpp
  },
  {
    name: component_45stubtE53tTHnppMeta?.name,
    path: "/locations/north-west",
    component: component_45stubtE53tTHnpp
  },
  {
    name: component_45stubtE53tTHnppMeta?.name,
    path: "/locations/south-east",
    component: component_45stubtE53tTHnpp
  },
  {
    name: component_45stubtE53tTHnppMeta?.name,
    path: "/locations/south-west",
    component: component_45stubtE53tTHnpp
  },
  {
    name: component_45stubtE53tTHnppMeta?.name,
    path: "/locations/west-midlands",
    component: component_45stubtE53tTHnpp
  },
  {
    name: component_45stubtE53tTHnppMeta?.name,
    path: "/locations/yorkshire",
    component: component_45stubtE53tTHnpp
  },
  {
    name: component_45stubtE53tTHnppMeta?.name,
    path: "/locations/wales",
    component: component_45stubtE53tTHnpp
  },
  {
    name: component_45stubtE53tTHnppMeta?.name,
    path: "/locations/west",
    component: component_45stubtE53tTHnpp
  },
  {
    name: component_45stubtE53tTHnppMeta?.name,
    path: "/locations/london",
    component: component_45stubtE53tTHnpp
  },
  {
    name: component_45stubtE53tTHnppMeta?.name,
    path: "/locations/east-midlands ",
    component: component_45stubtE53tTHnpp
  },
  {
    name: component_45stubtE53tTHnppMeta?.name,
    path: "/locations/scotland",
    component: component_45stubtE53tTHnpp
  },
  {
    name: component_45stubtE53tTHnppMeta?.name,
    path: "/locations/northern-ireland",
    component: component_45stubtE53tTHnpp
  },
  {
    name: component_45stubtE53tTHnppMeta?.name,
    path: "/sl/skip-hire-greater-manchester",
    component: component_45stubtE53tTHnpp
  },
  {
    name: component_45stubtE53tTHnppMeta?.name,
    path: "/sl/skip-hire-gloucestershire",
    component: component_45stubtE53tTHnpp
  },
  {
    name: component_45stubtE53tTHnppMeta?.name,
    path: "/sl/skip-hire-city-of-glasgow",
    component: component_45stubtE53tTHnpp
  },
  {
    name: component_45stubtE53tTHnppMeta?.name,
    path: "/sl/skip-hire-bedfordshire",
    component: component_45stubtE53tTHnpp
  },
  {
    name: component_45stubtE53tTHnppMeta?.name,
    path: "/sl/skip-hire-tyne-and-wear",
    component: component_45stubtE53tTHnpp
  },
  {
    name: component_45stubtE53tTHnppMeta?.name,
    path: "/equipment/categories/waste",
    component: component_45stubtE53tTHnpp
  },
  {
    name: component_45stubtE53tTHnppMeta?.name,
    path: "/p/8-yard-skip",
    component: component_45stubtE53tTHnpp
  },
  {
    name: component_45stubtE53tTHnppMeta?.name,
    path: "/knowledge/how-much-does-grab-hire-cost-",
    component: component_45stubtE53tTHnpp
  }
]